import { gql } from '@apollo/client';

export const sendPolicyCancelationEmail = gql`mutation sendPolicyCancelationEmail($soId: String!) {
  sendPolicyCancelationEmail(soId: $soId)
}`
